import React from 'react';
import { X, TrendingUp, Users, Clock, CheckCircle } from 'lucide-react';
interface ModuleDetailModalProps {
  module: string;
  onClose: () => void;
}
const moduleDetails: Record<string, any> = {
  weather: {
    title: 'Météo & Déclenchement',
    stats: [{
      label: 'Prévisions actives',
      value: '45',
      icon: TrendingUp
    }, {
      label: 'Sites surveillés',
      value: '1,247',
      icon: Users
    }, {
      label: 'Déclenchements auto',
      value: '85%',
      icon: CheckCircle
    }, {
      label: 'Délai moyen',
      value: '8 min',
      icon: Clock
    }],
    recentActivity: ['Alerte neige: Secteur Nord - 6-8 cm', 'Déclenchement auto: Zone MTL-Est', 'Mise à jour prévisions: 12 sites']
  },
  planning: {
    title: 'Planification & Optimisation',
    stats: [{
      label: 'Rangs actifs',
      value: '23',
      icon: TrendingUp
    }, {
      label: 'Véhicules assignés',
      value: '67',
      icon: Users
    }, {
      label: 'Optimisation',
      value: '94%',
      icon: CheckCircle
    }, {
      label: 'Temps économisé',
      value: '2.3h',
      icon: Clock
    }],
    recentActivity: ['Rang P50 publié pour MTL-Est', 'Optimisation de 15 itinéraires', 'Réaffectation de 3 véhicules']
  },
  operations: {
    title: 'Opérations Terrain',
    stats: [{
      label: 'Interventions actives',
      value: '34',
      icon: TrendingUp
    }, {
      label: 'Conducteurs actifs',
      value: '67',
      icon: Users
    }, {
      label: 'GPS en ligne',
      value: '100%',
      icon: CheckCircle
    }, {
      label: 'Temps moyen',
      value: '1.5h',
      icon: Clock
    }],
    recentActivity: ['Site #1247 complété', 'Punch in: 3 nouveaux conducteurs', 'Rapport photo ajouté: Site #892']
  }
};
export function ModuleDetailModal({
  module,
  onClose
}: ModuleDetailModalProps) {
  const details = moduleDetails[module] || moduleDetails.weather;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-259">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" data-id="element-260">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-261">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-262">{details.title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-263">
            <X className="w-5 h-5 text-gray-500" data-id="element-264" />
          </button>
        </div>
        {/* Stats Grid */}
        <div className="p-6 grid grid-cols-2 gap-4" data-id="element-265">
          {details.stats.map((stat: any, index: number) => {
          const Icon = stat.icon;
          return <div key={index} className="p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-266">
                <div className="flex items-center space-x-3" data-id="element-267">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-268">
                    <Icon className="w-5 h-5 text-blue-600" data-id="element-269" />
                  </div>
                  <div data-id="element-270">
                    <p className="text-2xl font-bold text-gray-900" data-id="element-271">
                      {stat.value}
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-272">{stat.label}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
        {/* Recent Activity */}
        <div className="px-6 pb-6" data-id="element-273">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-274">
            Activité récente
          </h3>
          <div className="space-y-3" data-id="element-275">
            {details.recentActivity.map((activity: string, index: number) => <div key={index} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg" data-id="element-276">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2" data-id="element-277"></div>
                <p className="text-sm text-gray-700" data-id="element-278">{activity}</p>
              </div>)}
          </div>
        </div>
        {/* Actions */}
        <div className="px-6 pb-6 flex space-x-3" data-id="element-279">
          <button className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-280">
            Voir détails complets
          </button>
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors" data-id="element-281">
            Fermer
          </button>
        </div>
      </div>
    </div>;
}